<template>
  <div>
    <!-- Header Section -->
    <b-row>
      <b-col
        cols="12"
        lg="8"
        class="mb-2 d-flex align-items-center justify-content-between"
      >
        <div>
          <div class="d-flex align-items-center">
            <h1 class="h3 font-weight-bolder mb-0 mr-1">
              <feather-icon
                icon="ActivityIcon"
                size="24"
                class="mr-1 mb-1"
              />Feed Mapping Workbench
            </h1>

            <ul class="nav nav-pills-custom mb-0">
              <li class="nav-item">
                <a class="nav-link active">Racing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link">Sports</a>
              </li>
            </ul>
          </div>
          <span class="text-muted">RAS ↔ BetMakers Data Reconciliation </span>
        </div>
      </b-col>

      <b-col
        cols="12"
        lg="4"
        class="d-flex align-items-center justify-content-end mb-1"
        style="gap: 4px"
      >
        <b-button
          @click="$router.push('/trading/tradings-management')"
          variant="primary"
        >
          <feather-icon icon="ArrowLeftIcon" />
          Back to Trading
        </b-button>
      </b-col>
    </b-row>

    <b-card class="mt-2">
      <b-row>
        <b-col cols="12">
          <h5 class="text-body font-weight-bolder">Race Selection RAS</h5>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col md="5">
              <p class="font-weight-bold mb-0 d-flex align-items-center">
                <feather-icon
                  icon="CalendarIcon"
                  style="margin-right: 5px; margin-top: -3px"
                />
                Browse Calendar
              </p>
              <flat-pickr
                id="startDate"
                v-model="selectedRaceDate"
                class="form-control"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col mb="7" class="pl-0">
              <p class="font-weight-bold mb-0 d-flex align-items-center">
                Selected Date
              </p>
              <div
                class="d-flex align-items-center pl-2 border"
                style="
                  background: #f8f9fa;
                  font-weight: 800;
                  height: 38px;
                  border-radius: 5px;
                "
              >
                {{ format(new Date(selectedRaceDate), "EEEE d MMMM yyyy") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="12" class="mb-2 mt-2">
          <p class="m-0">
            <span class="font-weight-bold mr-1">Racing Code*</span>
            <small>(Leave blank to show all codes)</small>
          </p>
          <div
            class="border"
            style="background: #fcfcfd; border-radius: 5px; padding: 15px 20px"
          >
            <b-form-checkbox-group
              v-model="selectedRacingCodes"
              class="d-flex flex-column"
              style="gap: 5px"
            >
              <b-form-checkbox value="R">Thoroughbreds</b-form-checkbox>
              <b-form-checkbox value="G">Greyhounds</b-form-checkbox>
              <b-form-checkbox value="H">Harness</b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </b-col>

        <b-col md="12" class="mb-2">
          <b-row>
            <!-- MEETINGS -->
            <b-col md="6">
              <p style="margin-bottom: 5px">Meetings</p>
              <div
                class="meeting-list-container border"
                style="
                  background: #fcfcfd;
                  padding: 15px;
                  max-height: 300px;
                  min-height: 200px;
                  overflow-y: auto;
                "
              >
                <div class="text-center mt-5" v-if="!meetings.length">
                  Select a date to view meetings
                </div>
                <div v-else>
                  <div
                    v-for="meeting in meetings"
                    :key="meeting.meetingId"
                    class="d-flex justify-content-between align-items-center"
                    :class="{
                      'meeting-item-selected':
                        selectedMeetings &&
                        selectedMeetings.meetingId === meeting.meetingId,
                      'meeting-item':
                        !selectedMeetings ||
                        selectedMeetings.meetingId !== meeting.meetingId,
                    }"
                    @click="toggleMeetingSelection(meeting)"
                    style="cursor: pointer; padding: 5px 8px"
                  >
                    <div>
                      <small
                        class="font-weight-bold mr-1"
                        style="font-size: 14px"
                        >{{ meeting.venueName }}</small
                      >
                      <small
                        >{{ meeting.state }}
                        {{ meeting.totalRace }} races</small
                      >
                    </div>
                    <b-badge
                      :variant="
                        getBadgeVariant(convertMeetingType(meeting.meetingType))
                      "
                      style="font-size: 10px"
                      >{{ convertMeetingType(meeting.meetingType) }}</b-badge
                    >
                  </div>
                </div>
              </div>
            </b-col>

            <!-- RACES -->
            <b-col md="6">
              <p style="margin-bottom: 5px">Races</p>
              <div
                class="race-list-container border"
                style="
                  background: #fcfcfd;
                  padding: 15px;
                  max-height: 300px;
                  min-height: 200px;
                  overflow-y: auto;
                "
              >
                <div class="text-center mt-5" v-if="!races.length">
                  Select a meeting to view races
                </div>
                <div v-else>
                  <div
                    v-for="race in races"
                    :key="race.eventNo"
                    class="d-flex justify-content-between align-items-center"
                    :class="{
                      'meeting-item-selected':
                        selectedRace && selectedRace.eventNo === race.eventNo,
                      'meeting-item':
                        !selectedRace || selectedRace.eventNo !== race.eventNo,
                    }"
                    @click="toggleRaceSelection(race)"
                    style="cursor: pointer; padding: 5px 8px"
                  >
                    Race {{ race.eventNo }} - {{ race.eventName }} -
                    {{ format(new Date(race.utcTime), "hh:mm aa") }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <!-- MODAL SELECT BETMAKER RACE-->
    <b-modal id="betmarker" ref="betmarker" centered size="xl">
      <template #modal-title> BetMakers Venues </template>

      <div class="text-body">
        <b-row>
          <b-col md="12" class="mb-2">
            <b-row>
              <!-- MEETINGS -->
              <b-col md="6">
                <p style="margin-bottom: 5px">Meetings</p>
                <div
                  class="meeting-list-container border"
                  style="
                    background: #fcfcfd;
                    padding: 15px;
                    max-height: 300px;
                    min-height: 200px;
                    overflow-y: auto;
                  "
                >
                  <div class="text-center mt-5" v-if="!meetingsBM.length">
                    Select a date to view meetings
                  </div>
                  <div v-else>
                    <div
                      v-for="meeting in meetingsBM"
                      :key="meeting.meetingId"
                      class="d-flex justify-content-between align-items-center"
                      :class="{
                        'meeting-item-selected':
                          selectedMeetingsBM &&
                          selectedMeetingsBM.meetingId === meeting.meetingId,
                        'meeting-item':
                          !selectedMeetingsBM ||
                          selectedMeetingsBM.meetingId !== meeting.meetingId,
                      }"
                      @click="toggleMeetingSelectionBM(meeting)"
                      style="cursor: pointer; padding: 5px 8px"
                    >
                      <div>
                        <small
                          class="font-weight-bold mr-1"
                          style="font-size: 14px"
                          >{{ meeting.venueName }}</small
                        >
                        <small
                          >{{ meeting.state }}
                          {{ meeting.totalRace }} races</small
                        >
                      </div>
                      <b-badge
                        :variant="
                          getBadgeVariant(
                            convertMeetingType(meeting.meetingType)
                          )
                        "
                        style="font-size: 10px"
                        >{{ convertMeetingType(meeting.meetingType) }}</b-badge
                      >
                    </div>
                  </div>
                </div>
              </b-col>

              <!-- RACES -->
              <b-col md="6">
                <p style="margin-bottom: 5px">Races</p>
                <div
                  class="race-list-container border"
                  style="
                    background: #fcfcfd;
                    padding: 15px;
                    max-height: 300px;
                    min-height: 200px;
                    overflow-y: auto;
                  "
                >
                  <div class="text-center mt-5" v-if="!racesBM.length">
                    Select a meeting to view races
                  </div>
                  <div v-else>
                    <div
                      v-for="race in racesBM"
                      :key="race.eventNo"
                      class="d-flex justify-content-between align-items-center"
                      :class="{
                        'meeting-item-selected':
                          selectedRaceBM &&
                          selectedRaceBM.eventNo === race.eventNo,
                        'meeting-item':
                          !selectedRaceBM ||
                          selectedRaceBM.eventNo !== race.eventNo,
                      }"
                      @click="toggleRaceSelectionBM(race)"
                      style="cursor: pointer; padding: 5px 8px"
                    >
                      Race {{ race.eventNo }} - {{ race.eventName }} -
                      {{ format(new Date(race.utcTime), "hh:mm aa") }}
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <template #modal-footer>
        <div class="d-flex">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="$refs.betmarker.hide()"
            >Cancel</b-button
          >
          <b-button
            variant="success"
            :disabled="!selectedRaceBM"
            @click="handleShowModalMap"
          >
            <feather-icon icon="LinkIcon" />
            Map</b-button
          >
        </div>
      </template>
    </b-modal>

    <!-- MODAL SELECT BETMAKER RACE-->
    <b-modal
      id="mapping"
      ref="mapping"
      centered
      size="xl"
      @hide="handleCloseModalMapping"
    >
      <template #modal-title> Mapping </template>

      <div v-if="selectedRace && selectedRaceBM" class="text-body">
        <div
          class="small mb-1"
          style="
            gap: 5px;
            padding: 8px;
            border: 1px solid #b6effb;
            background: #cff4fc;
          "
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="20"
            class="text-white"
            style="background: #055160; border-radius: 100%; margin-right: 5px"
          />
          <span style="font-weight: 900">How to use:</span> select a runner from
          one side and select another runner on the other side to create a
          mapping
        </div>
        <b-row>
          <!-- RAS -->
          <b-col cols="12" md="6">
            <b-card no-body>
              <b-card-header
                style="background: #0d6efd"
                class="text-white p-1 d-flex flex-column"
              >
                RAS ID: {{ selectedRace.raceId }}
                <span>{{ selectedRace.eventName }}</span>
              </b-card-header>
              <b-card-body class="mt-1">
                <div
                  v-for="item in selectedRace.results"
                  :key="item.runnerId"
                  class="shadow-sm config-card d-flex flex-column"
                  @click="handleSelectRAS(item)"
                  :class="{ 'config-card-selected': selectedRas === item }"
                  :style="{
                    opacity: listMappingRunner.some((i) =>
                      i.some((l) => l.runnerId === item.runnerId)
                    )
                      ? 0.3
                      : 1,
                  }"
                >
                  <span> Runner {{ item.runnerNo }}</span>
                  <span>Id: {{ item.runnerId }} </span>
                  <span>Final Position: {{ item.finalPosition }} </span>
                  <span
                    >Data:
                    <b-button
                      style="padding: 4px; font-size: 12px"
                      @click="item.isShow = !item.isShow"
                    >
                      {{ item.isShow ? "Hide" : "Show" }}</b-button
                    ></span
                  >
                  <b-collapse
                    v-model="item.isShow"
                    :id="`collapse${item.runnerId}`"
                    class="mt-2 border-top"
                  >
                    <div class="grid-3" style="padding: 4px">
                      <div class="data-item d-flex align-items-center">
                        <span style="font-weight: 900"> startingPrice: </span>
                        <template>
                          <b-form-input
                            style="
                              width: 50px;
                              padding: 6px;
                              height: 25px;
                              margin-left: 4px;
                            "
                            v-model="item.startingPrice"
                          >
                          </b-form-input>
                        </template>
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">midDiv: </span>
                        {{ item.midDiv }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">midDivPlace: </span>
                        {{ item.midDivPlace }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">bestDivSp: </span>
                        {{ item.bestDivSp }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">win: </span>
                        {{ item.win }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">place: </span>
                        {{ item.place }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">quinella: </span>
                        {{ item.quinella }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">exacta: </span>
                        {{ item.exacta }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">trifecta: </span>
                        {{ item.trifecta }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900"> firstFour: </span>
                        {{ item.firstFour }}
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <!-- BetMakers ID -->
          <b-col cols="12" md="6">
            <b-card no-body>
              <b-card-header
                style="background: #198754"
                class="text-white p-1 d-flex flex-column"
              >
                BetMakers ID: {{ selectedRaceBM.raceId }}
                <span>{{ selectedRaceBM.eventName }}</span>
              </b-card-header>
              <b-card-body class="mt-1">
                <div
                  v-for="item in selectedRaceBM.results"
                  :key="item.runnerId"
                  class="shadow-sm config-card d-flex flex-column"
                  @click="handleSelectBM(item)"
                  :class="{
                    'config-card-selected': selectedBM === item,
                  }"
                  :style="{
                    opacity: listMappingRunner.some((i) =>
                      i.some((l) => l.runnerId === item.runnerId)
                    )
                      ? 0.3
                      : 1,
                  }"
                >
                  <span> Runner {{ item.runnerNo }}</span>
                  <span>Id: {{ item.runnerId }} </span>
                  <span>Final Position: {{ item.finalPosition }} </span>
                  <span
                    >Data:
                    <b-button
                      style="padding: 4px; font-size: 12px"
                      @click="item.isShow = !item.isShow"
                    >
                      {{ item.isShow ? "Hide" : "Show" }}</b-button
                    ></span
                  >
                  <b-collapse
                    v-model="item.isShow"
                    :id="`collapse${item.runnerId}`"
                    class="mt-2 border-top"
                  >
                    <div class="grid-3" style="padding: 4px">
                      <div class="data-item d-flex align-items-center">
                        <span style="font-weight: 900"> startingPrice: </span>
                        <template>
                          <b-form-input
                            style="
                              width: 50px;
                              padding: 6px;
                              height: 25px;
                              margin-left: 4px;
                            "
                            v-model="item.startingPrice"
                          >
                          </b-form-input>
                        </template>
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">midDiv: </span>
                        {{ item.midDiv }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">midDivPlace: </span>
                        {{ item.midDivPlace }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">bestDivSp: </span>
                        {{ item.bestDivSp }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">win: </span>
                        {{ item.win }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">place: </span>
                        {{ item.place }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">quinella: </span>
                        {{ item.quinella }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">exacta: </span>
                        {{ item.exacta }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900">trifecta: </span>
                        {{ item.trifecta }}
                      </div>
                      <div class="data-item">
                        <span style="font-weight: 900"> firstFour: </span>
                        {{ item.firstFour }}
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-card no-body v-if="!!listMappingRunner.length">
          <b-card-header
            style="background: #0dcaf0"
            class="text-white p-1 justify-content-start font-weight-bold"
          >
            <feather-icon icon="ClockIcon" class="mr-1" />
            Pending Mappings (Ready to Save)
          </b-card-header>
          <b-card-body class="mt-1">
            <div
              v-for="(item, ind) in listMappingRunner"
              :key="ind"
              style="margin-bottom: 5px"
            >
              <div
                v-if="item[0] && item[1]"
                class="selected-mapping-item d-flex align-items-center justify-content-between"
                style="font-weight: 900; gap: 10px"
              >
                <div>
                  <span>
                    Runner {{ item[1].runnerNo }}
                    <span class="font-weight-light">(BM)</span></span
                  >
                  <feather-icon icon="ArrowRightIcon" />
                  <span>
                    Runner {{ item[0].runnerNo }}
                    <span class="font-weight-light">(RAS)</span></span
                  >
                </div>
                <feather-icon
                  icon="XSquareIcon"
                  style="color: red"
                  size="20"
                  class="ml-1 cursor-pointer"
                  @click="handleRemoveItemMapping(ind)"
                />
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <template #modal-footer>
        <div class="d-flex">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="handleCloseModalMapping"
            >Cancel</b-button
          >
          <b-button
            @click="handleSaveAllMapping"
            variant="success"
            :disabled="loadingAddResult || !listMappingRunner.length"
            style="min-width: 192px"
          >
            <feather-icon icon="SaveIcon" />

            <Spinner v-if="loadingAddResult" />
            <template v-else> Save All Mappings </template>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BCol,
  BFormDatepicker,
  BFormInput,
  BFormSelect,
  BRow,
  BTable,
  BLink,
  BButtonGroup,
  BCard,
  BPagination,
  BModal,
  BFormCheckbox,
  BFormGroup,
  BFormTextarea,
  BFormCheckboxGroup,
  BCardHeader,
  BCardBody,
  BCollapse,
  VBToggle,
} from "bootstrap-vue";
import { formatDateSend } from "@/helpers/utils";
import useToastHandler from "@/services/toastHandler";
import { endOfDay, format, startOfDay } from "date-fns";
import flatPickr from "vue-flatpickr-component";
import { mapState, mapActions } from "vuex";
import Spinner from "@core/components/Spinner.vue";

export default {
  components: {
    BButton,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    BTable,
    BBadge,
    BRow,
    BCol,
    BLink,
    BButtonGroup,
    BCard,
    BPagination,
    BModal,
    BFormCheckbox,
    BFormGroup,
    BFormTextarea,
    flatPickr,
    BFormCheckboxGroup,
    BCardHeader,
    BCardBody,
    BCollapse,
    Spinner,
  },
  directives: { "b-toggle": VBToggle },
  data() {
    return {
      selectedRacingCodes: [],
      meetings: [],
      races: [],
      selectedMeetings: null,
      selectedRace: null,
      selectedRaceDate: new Date(),
      loadingAllMeetings: false,
      meetingsBM: [],
      racesBM: [],
      selectedMeetingsBM: null,
      selectedRaceBM: null,
      selectedRas: null,
      selectedBM: null,
      listMappingRunner: [],
    };
  },
  watch: {
    selectedRacingCodes(val) {
      this.fetchListMeetings();
    },
    selectedMeetings(val) {
      if (this.selectAllRaces) this.selectAllRaces = false;
    },
    selectedRaceDate(val) {
      this.handleCloseModalMapping();
      this.fetchListMeetings();
    },
    selectedRas() {
      this.checkSelected();
    },
    selectedBM() {
      this.checkSelected();
    },
  },
  computed: {
    ...mapState("trading/racing", ["loadingAddResult"]),
  },
  async created() {
    await this.fetchListMeetings();
  },
  methods: {
    ...mapActions({
      getListMeetings: "trading/racing/getListMeetings",
      getRacesOfMeeting: "trading/racing/getRacesOfMeeting",
      addResultManual: "trading/racing/addResultManual",
    }),
    async fetchListMeetingsBM() {
      const res = await this.getListMeetings({
        limit: 100,
        source: "BetMaker",
        meetingDateFrom: startOfDay(
          new Date(this.selectedRaceDate)
        ).toISOString(),
        meetingDateTo: endOfDay(new Date(this.selectedRaceDate)).toISOString(),
        ...(!!this.selectedRacingCodes.length &&
          this.convertListToIdsObject(this.selectedRacingCodes)),
      });
      this.meetingsBM = res;
    },
    async fetchListMeetings() {
      const res = await this.getListMeetings({
        limit: 100,
        source: "RAS",
        meetingDateFrom: startOfDay(
          new Date(this.selectedRaceDate)
        ).toISOString(),
        meetingDateTo: endOfDay(new Date(this.selectedRaceDate)).toISOString(),
        ...(!!this.selectedRacingCodes.length &&
          this.convertListToIdsObject(this.selectedRacingCodes)),
      });
      this.meetings = res;
    },
    convertListToIdsObject(l) {
      return l.reduce((acc, item, index) => {
        const key = `meetingTypes[${index}]`;

        acc[key] = item;

        return acc;
      }, {});
    },
    async fetchListRacesOfMeeting() {
      if (!this.selectedMeetings) return;
      const res = await this.getRacesOfMeeting({
        limit: 100,
        meetingId: this.selectedMeetings.meetingId,
      });
      this.races = res.map((i) => {
        return {
          ...i,
          venueName: this.selectedMeetings.venueName,
          meetingId: this.selectedMeetings.meetingId,
        };
      });
    },
    async fetchListRacesOfMeetingBM() {
      if (!this.selectedMeetingsBM) return;
      const res = await this.getRacesOfMeeting({
        limit: 100,
        meetingId: this.selectedMeetingsBM.meetingId,
      });
      this.racesBM = res
        .map((i) => {
          return {
            ...i,
            venueName: this.selectedMeetingsBM.venueName,
            meetingId: this.selectedMeetingsBM.meetingId,
          };
        })
        .filter((i) => i.results.some((result) => !!result.finalPosition));
    },
    convertMeetingType(type) {
      switch (type) {
        case "R":
          return "Thoroughbred";
        case "G":
          return "Greyhound";
        case "H":
          return "Harness";
        default:
          return "";
      }
    },
    getBadgeVariant(type) {
      switch (type) {
        case "Thoroughbred":
          return "success";
        case "Greyhound":
          return "info";
        case "Harness":
          return "warning";
        default:
          return "secondary";
      }
    },
    toggleMeetingSelection(item) {
      this.selectedMeetings = item;
      this.fetchListRacesOfMeeting();
    },
    async toggleRaceSelection(item) {
      this.selectedRace = {
        ...item,
        results: item.results.sort((a, b) => a.runnerNo - b.runnerNo),
      };
      await this.fetchListMeetingsBM();
      this.$refs.betmarker.show();
    },
    async toggleMeetingSelectionBM(meeting) {
      if (
        !this.selectedMeetingsBM ||
        this.selectedMeetingsBM.meetingId !== meeting.meetingId
      ) {
        this.selectedMeetingsBM = meeting;
        await this.fetchListRacesOfMeetingBM();
      }
    },
    toggleRaceSelectionBM(item) {
      this.selectedRaceBM = {
        ...item,
        results: item.results
          .filter((i) => !!i.finalPosition)
          .sort((a, b) => a.runnerNo - b.runnerNo)
          .map((i) => {
            return {
              ...i,
              startingPrice: i && i.startingPrice ? i.startingPrice : "",
              isShow: false,
            };
          }),
      };
    },
    handleShowModalMap() {
      this.$refs.betmarker.hide();
      this.$refs.mapping.show();
    },
    checkSelected() {
      if (this.selectedRas && this.selectedBM) {
        this.listMappingRunner = [
          ...this.listMappingRunner,
          [this.selectedRas, this.selectedBM],
        ];

        this.selectedRas = null;
        this.selectedBM = null;
      }
    },
    handleRemoveItemMapping(index) {
      this.listMappingRunner.splice(index, 1);
    },
    handleSelectRAS(item) {
      if (
        this.listMappingRunner.some((i) =>
          i.some((l) => l.runnerId === item.runnerId)
        )
      )
        return;
      this.selectedRas = item;
    },
    handleSelectBM(item) {
      if (
        this.listMappingRunner.some((i) =>
          i.some((l) => l.runnerId === item.runnerId)
        )
      )
        return;
      this.selectedBM = item;
    },
    handleCloseModalMapping() {
      this.$refs.mapping.hide();
      this.listMappingRunner = [];
      this.selectedBM = null;
      this.selectedRas = null;
      this.selectedRace = null;
      this.selectedRaceBM = null;
      this.selectedMeetings = null;
      this.selectedMeetingsBM = null;
    },
    async handleSaveAllMapping() {
      const res = await this.addResultManual({
        raceId: this.selectedRace.raceId,
        results: this.listMappingRunner.map((item) => {
          const ras = item[0];
          const bm = item[1];
          return {
            runnerId: ras.runnerId,
            finalPosition: bm.finalPosition,
            ...(!!bm.startingPrice && { startingPrice: bm.startingPrice }),
            ...(!!bm.midDiv && { midDiv: bm.midDiv }),
            ...(!!bm.midDivPlace && { midDivPlace: bm.midDivPlace }),
            ...(!!bm.bestDivSp && { bestDivSp: bm.bestDivSp }),
            ...(!!bm.win && { win: bm.win }),
            ...(!!bm.place && { place: bm.place }),
            ...(!!bm.quinella && { quinella: bm.quinella }),
            ...(!!bm.exacta && { exacta: bm.exacta }),
            ...(!!bm.trifecta && { trifecta: bm.trifecta }),
            ...(!!bm.firstFour && { firstFour: bm.firstFour }),
          };
        }),
      });
      if (res) {
        this.showToastSuccess("Successfully mapped!");
        this.handleCloseModalMapping();
        this.selectedRace = null;
        this.selectedRaceBM = null;
      }
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();

    return {
      showToastSuccess,
      showToastError,

      format,
      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.nav-pills-custom {
  display: inline-flex;
  gap: 0;
  border: 2px solid #0d6efd;
  border-radius: 50px;
  padding: 4px;
  background: white;
}
.nav-pills-custom .nav-link {
  padding: 10px 40px;
  border-radius: 50px;
  font-weight: 600;
  color: #0d6efd;
  transition: all 0.2s;
}
.nav-link:hover {
  background: #e9edf1;
}
.nav-pills-custom .nav-link.active {
  background: #0d6efd;
  color: white;
}

.meeting-list-container,
.race-list-container {
  border-radius: 0.25rem;
}

.meeting-item {
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  background-color: white;
}

.meeting-item:last-child {
  border-bottom: none;
}

.meeting-item:hover {
  background-color: #e0e1e2;
}

.meeting-item-selected {
  background-color: #0d6efd;
  color: white;
}

.config-card {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 10px;
  padding: 5px;
  border: 2px solid #dee2e6;
  border-radius: 5px;
}

.config-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.config-card-selected {
  border-color: #0d6efd;
}

.config-card-disable {
  opacity: 50;
}

.data-item {
  padding: 4px;
  // border: 1px solid #dee2e6
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.selected-mapping-item {
  background: #cfe2ff;
  border: 1px solid #084298;
  border-radius: 6px;
  padding: 10px;
}
</style>